import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { BookingResponse } from 'app/typings/core/admin/bookings/booking';
import type { CancelBookingRequest } from 'app/typings/core/admin/bookings/bookingForm';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

type CancelBookingParams = {
  code: string;
  payload: CancelBookingRequest;
};

export function useCancelBooking() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ code, payload }: CancelBookingParams) =>
      apiMutation(
        'POST',
        { path: ENDPOINTS.cancelBooking, params: { bookingCode: code } },
        payload
      ) as Promise<BookingResponse>,
    onSuccess: (response, variables) => {
      message.success('Booking successfully canceled');

      queryClient.setQueryData(
        [CORE_QUERY_KEYS.booking, { code: variables.code }],
        response
      );
    },
    onError: () => {
      message.error('Failed to cancel booking');
    },
  });
}
